import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Removed unused Link import
// import Navbar from './components/Navbar/Navbar'; // Remove Navbar import
import ThreeColumnVideos from './components/ThreeColumnVideos/ThreeColumnVideos';
import { LanguageProvider } from './context/LanguageContext'; 
import './styles/globals.css'; 
import './App.css'; // Ensure App.css is imported
// import DreamchantedUploader from './components/DreamchantedUploader/DreamchantedUploader'; // Remove this import
// Import the new Step 1 component
import Step1Component from './components/DreamchantedUploader/Step1Component';
import Step2Component from './components/DreamchantedUploader/Step2Component'; // Import Step 2
import Step3Component from './components/DreamchantedUploader/Step3Component'; // Import Step 3
// Import page components
import LicensePage from './pages/LicensePage';
import HelpPage from './pages/HelpPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; // Import new Privacy Policy
import TermsConditionsPage from './pages/TermsConditionsPage'; // Import new Terms
import RefundPolicyPage from './pages/RefundPolicyPage'; // Import new Refund Policy
import FAQSection from './components/FAQSection'; // Add FAQSection import
// import SocialProofSection from './components/SocialProofSection'; // Remove SocialProofSection import
import CTAButton from './components/CTAButton'; // Add CTAButton import
import HeroRating from './components/HeroRating'; // Import the new HeroRating component
import Footer from './components/Footer'; // Import the new Footer component
import ContactButton from './components/ContactButton/ContactButton'; // Import the new Contact button

function App() {
  const [showUploader, setShowUploader] = useState(false);
  const [currentStep, setCurrentStep] = useState(1); // Track current step
  const [selectedStyle, setSelectedStyle] = useState(null); // Track selected style
  const [userEmail, setUserEmail] = useState(''); // Add state for email
  const [inputText, setInputText] = useState(''); // ADD STATE FOR INPUT TEXT/BOOK NAME

  // Handler for data from Step 1
  const handleStep1Data = (data) => {
    console.log("Step 1 Data:", data); 
    // Use data.type and data.value instead of data.mode and data.text
    if (data.type === 'text') {
      setInputText(data.value || ''); // Store the text input from data.value
    } else {
      setInputText(''); // Clear text input if mode is not text (e.g., PDF)
    }
    // Store the raw data from Step 1
    // setUploaderData(prev => ({ ...prev, step1: data })); // Removed updater call
  };

  // Handler for style selection from Step 2
  const handleStyleSelect = (style) => {
      console.log("Selected Style:", style);
      setSelectedStyle(style);
      // setUploaderData(prev => ({ ...prev, step2: style })); // Removed updater call
  }

  // Handler for email change from Step 3 - WRAPPED IN useCallback
  const handleEmailChange = useCallback((email) => {
      setUserEmail(email);
      // setUploaderData(prev => ({ ...prev, step3: { email: email } })); // Removed updater call
      // console.log("User Email:", email);
  }, []); // Empty dependency array means this function reference is stable

  // Placeholder for final submission (likely unused now)
  const handleSubmit = () => {
      // console.log("Submitting data:", uploaderData); // uploaderData removed
      console.log("Final Email:", userEmail);
      console.log("Final Style:", selectedStyle);
      console.log("Final Input Text:", inputText);
      alert("Placeholder App submit - This shouldn't be called if Stripe redirect works.");
      // --- Add your API call logic here --- 
      closeModal(); // Close modal on submit for now
  }

  const goToNextStep = () => {
    if (currentStep < 3) { 
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 3) {
      // If on step 3, the "Next" button is now "Submit"
      handleSubmit();
    }
  };

  const goToPrevStep = () => {
      if(currentStep > 1) {
          setCurrentStep(currentStep - 1);
      }
  }

  const openModal = () => {
      setCurrentStep(1); 
      setSelectedStyle(null); 
      // setUploaderData({}); // Removed updater call
      setUserEmail(''); // Reset email
      setInputText(''); // Reset input text
      setShowUploader(true);
  }

  const closeModal = () => {
      setShowUploader(false);
      // Optional: Reset state after a delay for fade-out animation
      // setTimeout(() => setCurrentStep(1), 300);
  }

  // Function to render the current step component
  const renderCurrentStep = () => {
    const completedSteps = currentStep - 1;

    switch (currentStep) {
      case 1:
        return (
          <Step1Component 
            onDataChange={handleStep1Data} 
            onNext={goToNextStep} 
            currentStep={currentStep}
            completedSteps={completedSteps}
          />
        );
      case 2:
        return (
          <Step2Component 
            selectedStyle={selectedStyle} 
            onStyleSelect={handleStyleSelect} 
            onNext={goToNextStep} 
            onBack={goToPrevStep} 
            currentStep={currentStep}
            completedSteps={completedSteps}
          />
        );
      case 3: 
        return (
          <Step3Component 
             selectedStyle={selectedStyle} 
             inputText={inputText}
             userEmail={userEmail}         
             onEmailChange={handleEmailChange} 
             onSubmit={handleSubmit}      
             onBack={goToPrevStep}       
             currentStep={currentStep}
             completedSteps={completedSteps}
          />
        );
      default:
        return <div>Error: Invalid step</div>;
    }
  }

  // Function to render the main page content (Hero, Button, Videos)
  const MainPageContent = () => (
    <>
       {/* --- NEW HERO SECTION --- */}
       <div className="hero-section">
        
         <h1 className="hero-title">Become the studio</h1>
         <h2 className="hero-subtitle">in 30 Seconds.</h2> 
       </div>
       {/* --- END HERO SECTION --- */}

       {/* --- HERO CTA AREA (Button + Rating) --- */}
       <div className="hero-cta-area"> {/* New container for flex layout */}
         {/* Original Button container (class might be removed or adjusted in CSS) */}
         <div className="journey-button-wrapper"> {/* Optional wrapper if needed */}
           <button className="journey-button" onClick={openModal}>
             <span className="journey-button-glow"></span>
             <span className="journey-button-inner">
               <div className="journey-button-content">
                 <span className="journey-button-text">FEEL IT NOW!</span>
                 <svg
                   xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24"
                   fill="currentColor"
                   className="journey-button-arrow"
                 >
                   <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" />
                 </svg>
               </div>
             </span>
           </button>
         </div>
         {/* Rating Component */}
         <HeroRating />
       </div>
       {/* --- END HERO CTA AREA --- */}

       <main className="main-content"> 
         <ThreeColumnVideos />
         
         {/* --- ADDED BLOG BUTTON --- */}
         <div className="blog-button-container"> 
           <a 
             href="https://blog.fably.fun/" 
             target="_blank" 
             rel="noopener noreferrer" 
             className="journey-button blog-button" // Reusing journey-button style
           >
              <span className="journey-button-glow"></span>
              <span className="journey-button-inner blog-button-inner"> {/* Added class for size override */} 
                <div className="journey-button-content">
                  <span className="journey-button-text blog-button-text">Visit Our Blog</span> {/* Added class for size override */} 
                  {/* No arrow needed for this one */}
                </div>
              </span>
           </a>
         </div>
         {/* --- END BLOG BUTTON --- */}

         {/* --- ADDED SECTIONS --- */}
         <FAQSection />
         <div className="cta-button-container"> {/* Container for bottom button */}
           <CTAButton onClick={openModal} />
         </div>
         {/* Removed SocialProofSection and last CTAButton */}
       </main>
    </>
  );

  return (
    <Router>
      <LanguageProvider>
        <div className={`app-container ${showUploader ? 'blurred' : ''}`}> 
          {/* Removed Navbar */}

          {/* Define Routes */} 
          <Routes>
            {/* Main Page Route */}
            <Route path="/" element={<MainPageContent />} />
            
            {/* Legal Page Routes */}
            <Route path="/license" element={<LicensePage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsConditionsPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
          </Routes>
          
          {/* Footer - Now using the new component */}
          <Footer />

          {/* Render the sticky contact button */}
          <ContactButton /> 

          {/* Modal remains outside Routes, conditionally rendered */}
          {showUploader && (
            <div 
              className="modal-backdrop" 
              onClick={(e) => { 
                if (e.target === e.currentTarget) {
                  closeModal(); 
                }
              }}
            >
              <div className="card">
                 {renderCurrentStep()}
                 
              </div>
            </div>
          )}
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
